import { memoryRepository } from '../repositories/memory-repository';

async function submitMemoryAnswer(chapter, answer) {
    return memoryRepository.submitAnswer(chapter, answer);
}

export {
    submitMemoryAnswer
};
